import React, { memo, useState } from 'react';
import { getRowHeaderLabel, lettersForMutations, mutateWordForRow, mutationTypes } from './mutationUtils';
import { Card, CardContent, CardHeader, Collapse, IconButton } from '@mui/material';
import clsx from 'clsx';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import makeStyles from '@mui/styles/makeStyles';
import BtnOpenMutation from './BtnOpenMutation';

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

const MutationsTables = (props) => {

  const { title, words, rowGroups, mutationsToShow, songs } = props;

  const classes = useStyles();
  const [ isExpanded, setExpanded ] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!isExpanded);
  };

  return (
    <Card>
      <CardHeader
        title={title}
        action={
          <>
            {mutationsToShow.includes(mutationTypes.SPIRANTE) && <BtnOpenMutation mutationType={mutationTypes.SPIRANTE} />}
            {mutationsToShow.includes(mutationTypes.HARD) && <BtnOpenMutation mutationType={mutationTypes.HARD} />}
            {mutationsToShow.includes(mutationTypes.MIXED) && <BtnOpenMutation mutationType={mutationTypes.MIXED} />}
            {mutationsToShow.includes(mutationTypes.SOFT) && <BtnOpenMutation mutationType={mutationTypes.SOFT} />}
            <IconButton
              className={clsx(classes.expand, {
                [ classes.expandOpen ]: isExpanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={isExpanded}
              aria-label="show more"
              size="large">
              <ExpandMoreIcon />
            </IconButton>
          </>
        } />
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <CardContent className={'table-container'}>

          <table className={'table-mutations'}>
            <thead>
            <tr>
              {lettersForMutations
                .map((letter, l_idx) => (<th key={l_idx} colSpan={2}>
                  <div className={'col-header'}>
                    <span>{letter}</span><br />
                    <small>({words[ letter ].sourceContent})</small>
                  </div>
                </th>))}
            </tr>
            </thead>
            <tbody>
            {rowGroups
              .map((rowGroup, rg_idx) => {
                const rows = rowGroup.map((rowHeader, rh_idx) => (
                  <tr key={rh_idx} className={'ov-row'}>
                    {lettersForMutations.map((letter, l_idx) => {

                      const word = words[ letter ];
                      const { hasMutated, result } = mutateWordForRow(word, rowHeader);

                      const label = getRowHeaderLabel(rowHeader, word);
                      const hasSongWidget = songs && songs[ rowHeader.label ] && songs[ rowHeader.label ][ letter ];

                      return (
                        <React.Fragment key={l_idx}>
                          <td>
                            <div className={`row-header ${rowHeader.mutationType} ${hasMutated ? 'mutation-bg' : ''}`}>{label}</div>
                          </td>
                          <td className={hasSongWidget ? 'has-song' : ''}>
                            <div className={`cell-value ${rowHeader.mutationType} ${hasMutated ? 'mutation-bg' : ''}`}>{result}</div>
                            {hasSongWidget && songs[ rowHeader.label ][ letter ]()}
                          </td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                ));

                return (
                  <React.Fragment key={rg_idx}>
                    {rows}
                    {(rg_idx !== rowGroups.length - 1) && <tr>
                      <td colSpan={lettersForMutations.length * 2} className={'row-sep'}></td>
                    </tr>}
                  </React.Fragment>
                );
              })
            }
            </tbody>
          </table>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default memo(MutationsTables);

